import React from 'react';
import PropTypes from 'prop-types';

const TauriSelectedModuleLabel = ({ searchTerm, catalogIds, sections }) => {
    // Find the group data dynamically based on catalogIds

    if(!catalogIds) {
        return;
    }

    const groupsData = sections.filter(group =>
        group.items.some(item => catalogIds.includes(item.id))
    );

    if (groupsData.length === 0) {
        return <div>No data available</div>;
    }

    return (
        <div className="maintenance-label">
            {groupsData.map(groupData => {
                // Filter items based on catalogIds
                const filteredItems = groupData.items.filter(item => catalogIds.includes(item.id));

                // Prepare display text
                const displayedItems = filteredItems.slice(0, 2).map(item => item.name);
                const additionalCount = filteredItems.length - displayedItems.length;

                return (
                    <div key={groupData.group}>
                        "{searchTerm}" in {groupData.name} (
                        {displayedItems.join(', ')}
                        {additionalCount > 0 ? ` and ${additionalCount} more` : ''}
                        )
                    </div>
                );
            })}
        </div>
    );
};

TauriSelectedModuleLabel.propTypes = {
    catalogIds: PropTypes.arrayOf(PropTypes.number).isRequired
};

export default TauriSelectedModuleLabel;
